import React from "react";
import "../styles/style.scss";
import IconBase from "./IconBase";

const Stats = (props: any) => {
  return (
    <IconBase viewBox="0 0 256 256" {...props} stroke="currentColor" strokeWidth="4">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="24"
        d="M32.0002,56H223.9998a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40.0002a8,8,0,0,1-8-8V56A0,0,0,0,1,32.0002,56Z"
      />
      <line x1="32" x2="224" y1="104" y2="104" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24" />
      <line x1="32" x2="224" y1="152" y2="152" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24" />
      <line x1="88" x2="88" y1="104" y2="200" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24" />
    </IconBase>
  );
};

export default Stats;
